function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "account");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "account"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.32,59H6.85a6.85,6.85,0,0,1-5.4-2.61A6.62,6.62,0,0,1,.18,50.74a25.08,25.08,0,0,1,48.81,0,6.62,6.62,0,0,1-1.28,5.65A6.83,6.83,0,0,1,42.32,59ZM24.58,36.43A20,20,0,0,0,5,51.88a1.68,1.68,0,0,0,.33,1.41A1.89,1.89,0,0,0,6.85,54H42.32a1.88,1.88,0,0,0,1.47-.71,1.64,1.64,0,0,0,.33-1.41A20,20,0,0,0,24.58,36.43Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.58,26.62A13.31,13.31,0,1,1,37.89,13.31,13.32,13.32,0,0,1,24.58,26.62ZM24.58,5a8.31,8.31,0,1,0,8.31,8.31A8.32,8.32,0,0,0,24.58,5Z"
}))));

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.16 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.bd63e255.svg";
export { ForwardRef as ReactComponent };